// =====================================================
// Cursor FX を有効にする環境判定（PCマウスのみ）
// =====================================================
const ENABLE_CURSOR_FX = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

// =====================================================
// 共通：ヘッダー表示（全ページで必ず実行したい処理）
// =====================================================
function revealHeaderAlways() {
  const heading = document.querySelector('body.template-index .header__heading');
  const inline  = document.querySelector('body.template-index .header__inline-menu');
  const icons   = document.querySelectorAll('body.template-index .header__icon span');

  if (heading) {
    gsap.set(heading, { display: "block" });
    gsap.from(heading, { duration: 2, autoAlpha: 0, ease: "power2.out" });
  }
  if (inline) {
    gsap.set(inline, { display: "block" });
    gsap.from(inline, { duration: 2, autoAlpha: 0, ease: "power2.out" });
  }
  if (icons && icons.length) {
    gsap.set(icons, { display: "flex" });
    gsap.from(icons, {
      duration: 2,
      autoAlpha: 0,
      ease: "power2.out",
      stagger: 0.02
    });
  }
}

// =====================================================
// 共通：Persistent stalker cursor（post-loading / PCのみ）
// =====================================================
function initStalkerCursor() {
  if (!ENABLE_CURSOR_FX) return;
  if (document.querySelector('[data-stalker-cursor="1"]')) return;

  const stalk = document.createElement('div');
  stalk.setAttribute('data-stalker-cursor', '1');

  gsap.set(stalk, {
    position: 'fixed',
    left: 0,
    top: 0,
    zIndex: 2147483647,
    width: 16,
    height: 16,
    borderRadius: '50%',
    border: '1px solid rgba(255,255,255,0.75)',
    pointerEvents: 'none',
    transform: 'translate(-50%, -50%)',
    willChange: 'transform,opacity',
    autoAlpha: 0
  });
  document.body.appendChild(stalk);

  // マウス位置追従（カーソルの少し右下）
  const offset = { x: 16, y: 16 };

  // 初期位置は持たせるが、最初は非表示
  const aim = { x: 0, y: 0 };
  const pos = { x: 0, y: 0 };

  let hasMouseMoved = false;

  function onMoveStalk(e) {
    aim.x = e.clientX + offset.x;
    aim.y = e.clientY + offset.y;

    // 最初のマウス移動でだけ表示＆座標同期
    if (!hasMouseMoved) {
      hasMouseMoved = true;
      pos.x = aim.x;
      pos.y = aim.y;

      gsap.set(stalk, {
        x: pos.x,
        y: pos.y,
        autoAlpha: 1
      });
    }
  }
  window.addEventListener('mousemove', onMoveStalk);

  (function follow() {
    if (hasMouseMoved) {
      const k = 0.25;
      pos.x += (aim.x - pos.x) * k;
      pos.y += (aim.y - pos.y) * k;
      gsap.set(stalk, { x: pos.x, y: pos.y });
    }
    requestAnimationFrame(follow);
  })();

  const HOVER_BASE = 'a, button, [role="button"], .hover-target, .shopify-payment-button__button';

  function getHoverTarget(el) {
    return el && el.closest ? el.closest(HOVER_BASE) : null;
  }

  let currentHover = null;

  function onOver(e) {
    if (!hasMouseMoved) return;

    const t = getHoverTarget(e.target);
    if (!t) return;
    if (currentHover === t) return;

    currentHover = t;

    gsap.to(stalk, {
      duration: 0.14,
      width: 12,
      height: 12,
      border: '0px solid transparent',
      backgroundColor: 'rgba(255,255,255,0.95)',
      boxShadow: '0 0 8px rgba(0,0,0,0.6)',
      ease: 'power2.out',
      overwrite: 'auto'
    });
  }

  function onOut(e) {
    if (!hasMouseMoved) return;

    const t = getHoverTarget(e.target);
    if (!t) return;

    const toEl = e.relatedTarget;
    if (toEl && t.contains(toEl)) return;

    if (currentHover === t) currentHover = null;

    gsap.to(stalk, {
      duration: 0.16,
      width: 16,
      height: 16,
      border: '1px solid rgba(255,255,255,0.75)',
      backgroundColor: 'rgba(0,0,0,0.15)',
      boxShadow: '0 0 4px rgba(0,0,0,0.5)',
      ease: 'power2.out',
      overwrite: 'auto'
    });
  }

  document.addEventListener('mouseover', onOver, true);
  document.addEventListener('mouseout', onOut, true);

  function hide() {
    gsap.to(stalk, { duration: 0.12, autoAlpha: 0 });
  }

  function show() {
    if (!hasMouseMoved) return;
    gsap.to(stalk, { duration: 0.12, autoAlpha: 1 });
  }

  function onVisibility() {
    (document.visibilityState === 'hidden') ? hide() : show();
  }

  document.addEventListener('mouseleave', hide);
  document.addEventListener('mouseenter', show);
  window.addEventListener('blur', hide);
  window.addEventListener('focus', show);
  document.addEventListener('visibilitychange', onVisibility);
}

// =====================================================
// Preloader + Loading cursor（indexのみ）
// =====================================================
(function () {
  const IS_INDEX =
    document.body.classList.contains('template-index') ||
    document.body.classList.contains('template-home') ||
    document.body.classList.contains('index') ||
    location.pathname === '/' ||
    location.pathname === '/index' ||
    location.pathname === '/index.html';

  if (!IS_INDEX) return;

  const pre = document.querySelector('.preloader');
  if (!pre) return;

  const root = document.documentElement;
  const bar = document.querySelector('.preloader-bar');
  const logo = document.querySelector('.preloader-logo');

  if (logo) {
    gsap.set(logo, {
      webkitFilter: 'blur(0px)',
      filter: 'blur(0px)'
    });
  }

  const logoDarkParts = logo ? logo.querySelectorAll('.cls-2') : null;

  const target = { p: 0 };
  const view = { p: 0 };

  let lc = null;
  let arc = null;
  let spinTween = null;
  let wagTween = null;

  let onMoveLC = null;
  let hideLC = null;
  let showLC = null;
  let onVisibilityLC = null;

  if (ENABLE_CURSOR_FX) {
    lc = document.createElement('div');
    lc.setAttribute('aria-hidden', 'true');
    lc.style.position = 'fixed';
    lc.style.left = '0';
    lc.style.top = '0';
    lc.style.zIndex = '100000';
    lc.style.width = '25px';
    lc.style.height = '25px';
    lc.style.pointerEvents = 'none';
    lc.style.transform = 'translate(-50%, -50%)';
    lc.style.willChange = 'transform, opacity';
    lc.style.opacity = '0';

    lc.innerHTML = [
      '<svg viewBox="0 0 32 32" width="25" height="25" style="display:block">',
      '<circle cx="16" cy="16" r="12" fill="none" stroke="rgba(255,255,255,0.15)" stroke-width="1"/>',
      '<circle class="lc-arc" cx="16" cy="16" r="12" fill="none" stroke="rgba(255,255,255,0.95)" stroke-linecap="round" stroke-width="1"/>',
      '</svg>'
    ].join('');
    document.body.appendChild(lc);

    arc = lc.querySelector('.lc-arc');
    gsap.set(arc, { strokeDasharray: '30 100', strokeDashoffset: 0 });

    const offsetLC = { x: 12, y: 12 };

    // 4rem を px に変換
    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;

    // 横は中央
    const initialX = window.innerWidth / 2;

    // 縦は「画面下から4rem上」
    const initialY = window.innerHeight - (10 * rem);

    const aimLC = { x: initialX, y: initialY };
    const posLC = { x: initialX, y: initialY };

    gsap.set(lc, { x: initialX, y: initialY });

    onMoveLC = function (e) {
      aimLC.x = e.clientX + offsetLC.x;
      aimLC.y = e.clientY + offsetLC.y;
    };
    window.addEventListener('mousemove', onMoveLC);

    (function followLoadingCursor() {
      const k = 0.22;
      posLC.x += (aimLC.x - posLC.x) * k;
      posLC.y += (aimLC.y - posLC.y) * k;
      gsap.set(lc, { x: posLC.x, y: posLC.y });
      requestAnimationFrame(followLoadingCursor);
    })();

    gsap.to(lc, { duration: 0.15, autoAlpha: 1, ease: "power1.out" });

    spinTween = gsap.to(lc, {
      duration: 3,
      rotation: 360,
      ease: "none",
      repeat: -1,
      transformOrigin: '50% 50%'
    });

    wagTween = gsap.to(arc, {
      duration: 2,
      strokeDashoffset: -50,
      yoyo: true,
      repeat: -1,
      ease: "power1.inOut"
    });

    hideLC = function () {
      if (pre && document.body.contains(pre)) {
        gsap.to(lc, { duration: 0.12, autoAlpha: 0 });
      }
    };
    showLC = function () {
      if (pre && document.body.contains(pre)) {
        gsap.to(lc, { duration: 0.12, autoAlpha: 1 });
      }
    };

    document.addEventListener('mouseleave', hideLC);
    document.addEventListener('mouseenter', showLC);
    window.addEventListener('blur', hideLC);
    window.addEventListener('focus', showLC);

    onVisibilityLC = function () {
      if (document.visibilityState === 'hidden') hideLC();
      else showLC();
    };
    document.addEventListener('visibilitychange', onVisibilityLC);
  }

  function raf() {
    const k = 0.04;
    view.p += (target.p - view.p) * k;
    let e = view.p; if (e < 0) e = 0; else if (e > 1) e = 1;
    const eased = e * e * (3 - 2 * e);
    if (bar) gsap.set(bar, { transform: 'scaleX(' + eased + ')', force3D: true });
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  if (logo) {
    gsap.fromTo(
      logo,
      { scale: 1.00, autoAlpha: 1 },
      { duration: 2, scale: 1.05, autoAlpha: 1, ease: "none" }
    );
  }

  window.setLoadingProgress = function (norm) {
    const clamped = Math.max(0, Math.min(1, norm || 0));
    gsap.to(target, { duration: 0.4, p: clamped, ease: "none", overwrite: 'auto' });
  };

  function completeAndHide() {
    const tl = gsap.timeline({
      onComplete: function () {
        if (ENABLE_CURSOR_FX) {
          if (onMoveLC) window.removeEventListener('mousemove', onMoveLC);
          if (hideLC) {
            document.removeEventListener('mouseleave', hideLC);
            window.removeEventListener('blur', hideLC);
          }
          if (showLC) {
            document.removeEventListener('mouseenter', showLC);
            window.removeEventListener('focus', showLC);
          }
          if (onVisibilityLC) document.removeEventListener('visibilitychange', onVisibilityLC);

          if (spinTween) spinTween.kill();
          if (wagTween) wagTween.kill();
          if (lc && lc.parentNode) lc.parentNode.removeChild(lc);
        }

        revealHeaderAlways();
        initStalkerCursor();
      }
    });

    if (logoDarkParts && logoDarkParts.length) {
      tl.to(logoDarkParts, { duration: 1.0, autoAlpha: 0, ease: "power2.inOut" }, 0.6);
    }

    if (logo) {
      tl.to(logo, {
        duration: 1.5,
        autoAlpha: 0,
        scale: 1.05,
        ease: "power2.inOut",
        webkitFilter: 'blur(2px)',
        filter: 'blur(2px)'
      }, 1.5);
    }

    if (ENABLE_CURSOR_FX && lc) {
      tl.to(lc, { duration: 1.2, autoAlpha: 0, ease: "power2.in" }, 1.5);
    }

    tl.to('.preloader', { duration: 1.4, autoAlpha: 0, ease: "power2.in" }, 2.3);
  }

  const urls = ["https://cdn.shopify.com/s/files/1/0549/5072/3804/files/top.jpg"];
  const total = urls.length;
  let loaded = 0;

  function onOne() {
    loaded++;
    const r = loaded / total;
    window.setLoadingProgress(Math.min(0.95, r));
  }

  urls.map(function (u) {
    const img = new Image();
    img.onload = onOne;
    img.onerror = onOne;
    img.src = u;
    return img;
  });

  const safetyTimer = setTimeout(function () {
    window.setLoadingProgress(1);
    completeAndHide();
  }, 4000);

  const checkDone = setInterval(function () {
    if (loaded >= total) {
      clearInterval(checkDone);
      clearTimeout(safetyTimer);
      gsap.to(target, {
        duration: 0.25,
        p: 1,
        ease: "power1.out",
        onComplete: function () { completeAndHide(); }
      });
    }
  }, 60);
})();

// =====================================================
// index以外：ヘッダー表示＆stalkerを必ず実行（preloader無しでも）
// =====================================================
(function runCommonInNonIndex() {
  const IS_INDEX =
    document.body.classList.contains('template-index') ||
    document.body.classList.contains('template-home') ||
    document.body.classList.contains('index') ||
    location.pathname === '/' ||
    location.pathname === '/index' ||
    location.pathname === '/index.html';

  if (IS_INDEX) return;

  function boot() {
    revealHeaderAlways();
    initStalkerCursor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

// =====================================================
// Header: Mega Menu（PC hover / タッチ click） + is-scrolled
// =====================================================
document.addEventListener('DOMContentLoaded', function () {
  const menus = document.querySelectorAll('details.mega-menu');
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const MEGA_OPEN_DUR = 1.2;
  const MEGA_CLOSE_DUR = 0.9;
  const MEGA_OFFSET_Y = 18;

  function openMenu(menu) {
    const content = menu.querySelector('.mega-menu__content');
    if (!content) return;
    if (content.classList.contains('is-active')) return;

    menus.forEach(m => { if (m !== menu) closeMenu(m); });

    menu.setAttribute('open', '');
    content.classList.add('is-active');

    gsap.killTweensOf(content);

    gsap.fromTo(
      content,
      { autoAlpha: 0, y: MEGA_OFFSET_Y, x: 0 },
      { duration: MEGA_OPEN_DUR, autoAlpha: 1, y: 0, x: 0, ease: "power3.out" }
    );
  }

  function closeMenu(menu) {
    const content = menu.querySelector('.mega-menu__content');
    if (!content) return;

    gsap.killTweensOf(content);

    gsap.to(content, {
      duration: MEGA_CLOSE_DUR,
      autoAlpha: 0,
      y: MEGA_OFFSET_Y,
      x: 0,
      ease: "power3.inOut",
      onComplete: function () {
        content.classList.remove('is-active');
        menu.removeAttribute('open');
        gsap.set(content, { clearProps: 'transform' });
      }
    });
  }

  function toggleMenu(menu) {
    const content = menu.querySelector('.mega-menu__content');
    if (!content) return;

    const isOpen = menu.hasAttribute('open') || content.classList.contains('is-active');
    if (isOpen) closeMenu(menu);
    else openMenu(menu);
  }

  menus.forEach(function (menu) {
    const summary = menu.querySelector('summary');
    const content = menu.querySelector('.mega-menu__content');
    if (!summary || !content) return;

    if (canHover) {
      summary.addEventListener('click', function (e) { e.preventDefault(); });
      summary.addEventListener('mouseenter', function () { openMenu(menu); });
      content.addEventListener('mouseenter', function () { openMenu(menu); });
      content.addEventListener('mouseleave', function () { closeMenu(menu); });
    } else {
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleMenu(menu);
      });
      content.addEventListener('click', function (e) { e.stopPropagation(); });
    }
  });

  if (!canHover) {
    document.addEventListener('click', function () {
      menus.forEach(closeMenu);
    });
  }

  if (canHover) {
    const headerItems = document.querySelectorAll('.header__menu-item');
    headerItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        const parentMega = item.closest('details.mega-menu');
        if (parentMega) return;
        menus.forEach(closeMenu);
      });
    });
  }

const headerWrapper = document.querySelector('.header-wrapper');
if (headerWrapper) {
  const SCROLL_THRESHOLD = 1;

  function handleScroll() {
    const y = window.scrollY || 0;
    headerWrapper.classList.toggle('is-scrolled', y > SCROLL_THRESHOLD);
  }

  handleScroll();
  window.addEventListener('scroll', handleScroll, { passive: true });
}
});


// (function () {
//   let savedScrollY = 0;

//   function lockScroll() {
//     savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
//     document.body.style.position = 'fixed';
//     document.body.style.top = `-${savedScrollY}px`;
//     document.body.style.left = '0';
//     document.body.style.right = '0';
//     document.body.style.width = '100%';
//   }

//   function unlockScroll() {
//     const y = savedScrollY;
//     document.body.style.position = '';
//     document.body.style.top = '';
//     document.body.style.left = '';
//     document.body.style.right = '';
//     document.body.style.width = '';
//     window.scrollTo(0, y);
//   }

//   // iOSでアドレスバーを“デフォルト表示”に戻すための「トップ寄せ」
//   function forceBarsToDefault() {
//     // iOSは1回だと効かないことがあるので “2段構え”
//     requestAnimationFrame(() => window.scrollTo(0, 0));
//     setTimeout(() => window.scrollTo(0, 0), 50);
//   }

//   // Shopifyの drawer(details) を監視
//   document.addEventListener(
//     'toggle',
//     (e) => {
//       if (!e.target?.matches?.('details.menu-drawer-container')) return;

//       const opened = e.target.open;

//       if (opened) {
//         // ① まずトップへ寄せてアドレスバーをデフォルトへ
//         forceBarsToDefault();

//         // ② スクロール固定（見た目はそのまま維持したいなら lock → scrollTo の順を逆にしてもOK）
//         lockScroll();

//         // ③ ここであなたの visualViewport 高さ反映も呼ぶ（例：schedule()）
//         // schedule();
//       } else {
//         unlockScroll();
//       }
//     },
//     true
//   );
// })();

// ブラウザサイズを自動で取得してiOS対策
document.addEventListener('DOMContentLoaded', () => {
  const setVH = () => {
    const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    document.documentElement.style.setProperty('--vvh', `${vh }px`);
  };

  setVH();
  window.addEventListener('resize', setVH);
  window.visualViewport?.addEventListener('resize', setVH);
  window.addEventListener('orientationchange', () => setTimeout(setVH, 50));
});



// ===============================
// GSAP + ScrollSmoother Init
// ===============================
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

// 1) ScrollSmoother
const smoother = ScrollSmoother.create({
  smooth: 1.4,
  effects: true,
});

// 2) ScrollTrigger の scroller を統一（←これで毎回書かなくていい）
ScrollTrigger.defaults({
  scroller: smoother.wrapper()
});

// ===============================
// A) Reveal 01（既存）
// ===============================
gsap.utils.toArray(".js-reveal01").forEach((el) => {
  gsap.fromTo(
    el,
    { autoAlpha: 0, y: 16, filter: "blur(20px)" },
    {
      autoAlpha: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 1.8,
      ease: "power2.out",
      scrollTrigger: {
        trigger: el,
        start: "top 70%",
        end: "top 55%",
        once: true
      }
    }
  );
});

gsap.utils.toArray(".js-reveal02").forEach((el) => {
  gsap.fromTo(
    el,
    { autoAlpha: 0, y: 16, filter: "blur(20px)" },
    {
      autoAlpha: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 0.6,
      ease: "power2.out",
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        end: "top 55%",
        once: true
      }
    }
  );
});

gsap.utils.toArray(".js-reveal-subtop").forEach((el) => {
  gsap.fromTo(
    el,
    { autoAlpha: 0, y: 16, filter: "blur(20px)" },
    {
      autoAlpha: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 3.0,
      ease: "power2.out",
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        end: "top 55%",
        once: true
      }
    }
  );
});


// ===============================
// B) Develop（現像っぽい）
// ===============================
// gsap.utils.toArray("img.js-reveal-img01").forEach((img) => {
//   const wrap = img.closest(".reveal-wrap") || img;
//   const triggerEl = img.closest(".home-index-experience-inr-box-list-item-outer") || img;

//   // 透明は wrap（transform競合を避ける）
//   gsap.set(wrap, { autoAlpha: 0 });

//   gsap.fromTo(
//     img,
//     {
//       scale: 1.05,
//       "--gs-blur": "5px",
//       "--gs-bright": 1.25,
//       "--gs-contrast": 0.9
//     },
//     {
//       scale: 1,
//       "--gs-blur": "0px",
//       "--gs-bright": 1,
//       "--gs-contrast": 1,
//       duration: 1.3,
//       ease: "power2.out",
//       scrollTrigger: {
//         trigger: triggerEl,
//         start: "top 78%",
//         end: "top 55%",
//         once: true,
//         onEnter: () => gsap.to(wrap, { autoAlpha: 1, duration: 0.2, overwrite: "auto" })
//       },
//       overwrite: "auto"
//     }
//   );
// });

// ===============================
// C) Hero Blur + Scale（スクロール連動）
// ===============================
const blurImg = document.querySelector(".js-blur-zone");

if (blurImg) {
  // 調整値
  const MAX_SCALE = 1.06;
  const MAX_BLUR  = 60;

  // 進捗カーブ（0..1）
  const startP = 0.30;
  const midP   = 0.60;

  const easeScale = gsap.parseEase("power1.out");
  const easeBlur1 = gsap.parseEase("power2.in");
  const easeBlur2 = gsap.parseEase("power3.in");

  const clamp01 = (v) => Math.min(1, Math.max(0, v));
  const map01 = (x, a, b) => clamp01((x - a) / (b - a));

  ScrollTrigger.create({
    trigger: blurImg,     // 親セクションがあるならそっちに変えると更に安定
    start: "top top",
    end: "+=100%",
    scrub: true,
    onUpdate(self) {
      const p = self.progress;

      // scale：なだらか
      const scale = 1 + (MAX_SCALE - 1) * easeScale(p);

      // blur：startPまで0 → midPで強め → 100%で最大
      let blur = 0;
      if (p > startP && p <= midP) {
        const t = map01(p, startP, midP);
        blur = MAX_BLUR * 0.75 * easeBlur1(t);
      } else if (p > midP) {
        const t = map01(p, midP, 1);
        blur = (MAX_BLUR * 0.75) + (MAX_BLUR * 0.25) * easeBlur2(t);
      }

      gsap.set(blurImg, {
        scale,
        filter: `blur(${blur}px)`
      });
    }
  });
}

gsap.registerPlugin(ScrollTrigger);

const blurImgTop = document.querySelector(".js-blur-zone-top");

if (blurImgTop) {
  const easeScale = gsap.parseEase("power1.out");
  const easeBlur1 = gsap.parseEase("power2.in");
  const easeBlur2 = gsap.parseEase("power3.in");

  const clamp01 = (v) => Math.min(1, Math.max(0, v));
  const map01 = (x, a, b) => clamp01((x - a) / (b - a));

  const createBlurScrollTrigger = ({
    maxScale = 1.08,
    maxBlur = 80,
    end = "+=100%",
    startP = 0.10,
    midP = 0.50
  }) => {
    ScrollTrigger.create({
      trigger: blurImgTop,
      start: "top top",
      end,
      scrub: true,

      onUpdate(self) {
        const p = self.progress;
        const scale = 1 + (maxScale - 1) * easeScale(p);

        let blur = 0;

        if (p > startP && p <= midP) {
          const t = map01(p, startP, midP);
          blur = maxBlur * 0.75 * easeBlur1(t);
        } else if (p > midP) {
          const t = map01(p, midP, 1);
          blur = maxBlur * 0.75 + maxBlur * 0.25 * easeBlur2(t);
        }

        gsap.set(blurImgTop, {
          scale,
          filter: `blur(${blur}px)`,
          transformOrigin: "50% 50%",
          force3D: true
        });
      }
    });
  };

  gsap.set(blurImgTop, {
    scale: 1.08,
    filter: "blur(18px) brightness(0.75)",
    autoAlpha: 1,
    transformOrigin: "50% 50%",
    force3D: true
  });

  gsap.to(blurImgTop, {
    scale: 1,
    filter: "blur(0px) brightness(1)",
    duration: 3.6,
    ease: "power2.out",

    onComplete: () => {
      ScrollTrigger.matchMedia({
        "(min-width: 768px)": () => {
          createBlurScrollTrigger({
            maxScale: 1.08,
            maxBlur: 80,
            end: "+=100%"
          });
        },

        "(max-width: 767px)": () => {
          createBlurScrollTrigger({
            maxScale: 1.05,
            maxBlur: 60,
            end: "+=180%"
          });
        }
      });
    }
  });
}


gsap.registerPlugin(ScrollTrigger);

const slideItems = document.querySelectorAll(".js-scroll-slide");

if (slideItems.length) {

gsap.set(".js-scroll-slide", {
  autoAlpha: 0,
  y: 16,
  filter: "blur(20px)"
});

gsap.utils.toArray(".js-scroll-slide").forEach((el) => {
  // ① 登場アニメーション
  gsap.to(el, {
    autoAlpha: 1,
    y: 0,
    filter: "blur(0px)",
    duration: 3,
    ease: "power2.out",
    scrollTrigger: {
      trigger: el,
      start: "top 90%",
      once: true
    }
  });

  // ② スクロールに応じた横移動
  ScrollTrigger.create({
    trigger: el,
    start: "top bottom",
    end: "bottom top",
    scrub: true,
    onUpdate(self) {
      const p = self.progress; // 0 → 1
      const x = -(30 * p);

      gsap.set(el, {
        x
      });
    }
  });
});

}


function galleryClone() {
  const gallery = document.querySelector('.home-index-brandworks-link-inr__list');
  if (!gallery) return;

  const parent = gallery.parentNode;
  const galleryCloneCount = 3; // 複製回数

  for (let i = 0; i < galleryCloneCount; i++) {
    const clone = gallery.cloneNode(true); // true = 子要素ごと複製
    parent.appendChild(clone);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  galleryClone();
});
